import { render } from "./outstanding-payments.vue?vue&type=template&id=65c8db73&scoped=true"
import script from "./outstanding-payments.vue?vue&type=script&lang=js"
export * from "./outstanding-payments.vue?vue&type=script&lang=js"

import "./outstanding-payments.vue?vue&type=style&index=0&id=65c8db73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c8db73"]])

export default __exports__